import React from 'react';
import { Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IS_ROSSUM_ENABLED } from '../../../constants';
import { SubPageSelect } from '../../../ui-kit';
import { DeliveryListsPage } from '../../../modules/deliveryLists';
import { routePaths } from '../../../routePaths';
import WarehouseToolbar from '../../../modules/warehouse/components/WarehouseToolbar/WarehouseToolbar';
import { useWarehousesScope } from '../../../modules/warehouse/providers/WarehouseScopeProvider';
import { useRossumUploadsCountByWarehouseIdQuery } from '../../../generated/graphql';
import useSearchParams from './useSearchParams';

const DeliveryLists = () => {
    const { t } = useTranslation();
    const { warehouses, currentWarehouseId } = useWarehousesScope();

    const { showInProcess, setShowInProcess } = useSearchParams();

    const { data: rossumUploadsCountQueryData } = useRossumUploadsCountByWarehouseIdQuery({
        variables: { warehouseId: currentWarehouseId as string },
    });

    if (warehouses.length === 0) {
        return <Redirect to={routePaths.warehouses} />;
    }

    const handlePageSelect = (index: number) => {
        setShowInProcess(IS_ROSSUM_ENABLED && index === 1);
    };

    const activePageIndex = showInProcess ? 1 : 0;

    let endAdorment;

    if (IS_ROSSUM_ENABLED) {
        endAdorment = (
            <SubPageSelect
                actions={[
                    { text: t('Completed') },
                    { text: t('In process'), notificationCount: rossumUploadsCountQueryData?.rossumUploadsCountByWarehouseId },
                ]}
                selectedIndex={activePageIndex}
                onSelect={handlePageSelect}
            />
        );
    }

    return (
        <>
            <WarehouseToolbar endAdorment={endAdorment} />
            <DeliveryListsPage activePageIndex={activePageIndex} />
        </>
    );
};

export default DeliveryLists;
